module.exports = __webpack_public_path__ + "static/media/button.f52b5604.png";